import React, { useEffect, useState, useLayoutEffect, useImperativeHandle, useContext } from "react";
import { Container, Col, Row } from "react-bootstrap";
import URLstateContext from "../../../provider/CommonContext";
import { useLocation, useParams, useNavigate, Link } from "react-router-dom";
import { Vortex } from 'react-loader-spinner'

function MfInvestmentDetails(props) {

    let getMFCode = props.MFcode;
    const [data, setData] = useState([]);
    const { BaseURL } = useContext(URLstateContext);
    const [loadingshow, setloadingshow] = useState(false);
    let getData;
    useEffect(() => {
        setloadingshow(true);
        if (getMFCode != '') {
            const getUrl = BaseURL + "MfSchPerformance";
            fetch(`${getUrl}/${getMFCode}`)
                .then((response) => response.json())
                .then((data) => {
                    getData = data.data;
                    setData(getData);
                    setloadingshow(false);
                })
                .catch((error) => {
                    // console.log("not found the api 1233333");
                });
        }
    }, [getMFCode]);

    return (
        <>
            <section className="peer-sc">
                <div className='container table-boxpeerMutual'>
                    <div className='row'>
                        <div className='col-md-12'>
                            <h3 className="mainHeadingGroup">Performance</h3>
                            <div className="table-responsive">
                                <table className="table table-sm table-striped table-bordered table-hover">

                                    <thead className='heading'>
                                        <tr>
                                            <th scope="col">Scheme Name</th>
                                            <th scope="col">3 MONTH</th>
                                            <th scope="col">6 MONTH</th>
                                            <th>1 YEAR</th>
                                            <th>3 YEAR</th>
                                            <th>5 YEAR</th>
                                            <th>10 YEAR</th>
                                            <th>SINCE INCEPTION</th>
                                        </tr>
                                    </thead>
                                    {(data === null) ? <div className="errorMsg"><h3>No Data Found !!!</h3></div> : ''}
                                    <tbody>

                                        {data != null && data.map(({ SchemeName,R3MRet,R6MRet,R1YearRet,R3YearRet,R5YearRet,R7YearRet,R10YearRet}) => (
                                            <tr className="SameCompPeer ">
                                                <td>{SchemeName} </td>
                                                <td>{R3MRet != null ? R3MRet.toFixed(2) : 0} </td>
                                                <td>{R6MRet != null ? R6MRet.toFixed(2) : 0 } </td>
                                                <td>{R1YearRet != null ? R1YearRet.toFixed(2) : 0 } </td>
                                                <td>{R3YearRet!= null ? R3YearRet.toFixed(2) : 0} </td>
                                                <td>{R5YearRet != null ? R5YearRet.toFixed(2) : 0} </td>
                                                <td>{R7YearRet != null ? R7YearRet.toFixed(2) : 0} </td>
                                                <td>{R10YearRet != null ? R10YearRet.toFixed(2) : 0} </td>
                                                
                                            </tr>

                                        ))}
                                    </tbody>  
                                </table>
                                {loadingshow ? <div className="textcentervertex">
                                                        <Vortex
                                                            visible={true}
                                                            height="80"
                                                            width="80"
                                                            ariaLabel="vortex-loading"
                                                            wrapperStyle={{}}
                                                            wrapperClass="vortex-wrapper"
                                                            colors={['#0473ea', '#0473ea', '#0473ea', '#39d800', '#39d800', '#39d800']}
                                                        />
                                                        <div className="model_popup">Please Wait...</div>
                                                    </div> : ""
                                                    }
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default MfInvestmentDetails